// extracted by mini-css-extract-plugin
export default {"ParticipantInfo":"_ParticipantInfo--M4MhE","Name":"_Name--MrjIC","Email":"_Email--Vf5C9","Description":"_Description--we7PL"};